import { render, staticRenderFns } from "./ListSuppliesReview.vue?vue&type=template&id=1dc4c5f8"
import script from "./ListSuppliesReview.vue?vue&type=script&lang=js"
export * from "./ListSuppliesReview.vue?vue&type=script&lang=js"
import style0 from "./ListSuppliesReview.vue?vue&type=style&index=0&id=1dc4c5f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports